var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyWithoutText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 78,
    viewBox: "0 0 64 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3741 1.5H3.87109C3.04229 1.5 2.24744 1.82924 1.66138 2.41529C1.07533 3.00134 0.746094 3.7962 0.746094 4.625V73.375C0.746094 74.2038 1.07533 74.9987 1.66138 75.5847C2.24744 76.1708 3.04229 76.5 3.87109 76.5H60.1241C60.5345 76.5 60.9409 76.4192 61.32 76.2621C61.6992 76.1051 62.0437 75.8749 62.3339 75.5847C62.624 75.2945 62.8542 74.95 63.0113 74.5709C63.1683 74.1917 63.2491 73.7854 63.2491 73.375V23.375M41.3741 1.5L63.2491 23.375M41.3741 1.5V23.375H63.2491M19.4991 54.625H44.4991M19.4991 42.125H44.4991",
    stroke: "#BFBFBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWithoutText);
export default __webpack_public_path__ + "static/media/empty-without-text.baf9bd7276b6620e1ee2785f5395eb13.svg";
export { ForwardRef as ReactComponent };